export default "__VITE_ASSET__CCCUHBE1__"